/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TimedAvailabilityParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('timed')],
    ['availableAt', parsers.moment, 'available_at'],
]);
export class TimedAvailability extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TimedAvailabilityParser.decode(input).map(res => new TimedAvailability(res));
    }
    static unsafeDecode(input) {
        return TimedAvailability.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TimedAvailabilityParser.encode(data);
    }
    static schema() {
        return TimedAvailabilityParser.schema();
    }
}
